/* global swal:false */
(function() {
  'use strict';

  angular
    .module('admin.users.details.wallets', [
      'admin.users.details.wallets.service'
    ])
    .controller('WalletsAdminCtrl', WalletsAdminCtrl);

  /** @ngInject */
  function WalletsAdminCtrl($stateParams, WalletsService) {
    var vm = this;
    vm.wallet = [];
    vm.userId = $stateParams.parentId;

    WalletsService.getWallet(vm.userId).then(function(result) {
      vm.wallet = result.results;
    });
  }

})();
